// client/src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const linkStyle = { color: '#b8b2a4', fontSize: 13, textDecoration: 'none', transition: 'color 0.15s' };
  const over = e => e.target.style.color = '#f4f1ea';
  const out = e => e.target.style.color = '#b8b2a4';
  const colLabel = { fontFamily: 'var(--font-mono)', fontSize: 10, letterSpacing: '2px', color: '#7a7567', textTransform: 'uppercase', marginBottom: 14 };

  return (
    <footer style={{ background: 'var(--ink)', color: 'var(--paper)', padding: '48px 24px 28px', marginTop: 'auto', borderTop: '2px solid var(--ink)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 32, marginBottom: 36 }}>
          <div style={{ maxWidth: 300 }}>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 26, marginBottom: 10, color: 'var(--paper)' }}>BioMedArticles</div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, letterSpacing: '3px', textTransform: 'uppercase', color: '#7a7567', marginBottom: 14 }}>Search Every Clinical Trial</div>
            <div style={{ color: '#b8b2a4', fontSize: 13, lineHeight: 1.7 }}>
              A faster way to search 574,000+ clinical trials from ClinicalTrials.gov.
            </div>
          </div>
          <div className="footer-links" style={{ display: 'flex', gap: 48, flexWrap: 'wrap' }}>
            <div>
              <div style={colLabel}>Platform</div>
              {[
                { to: '/', label: 'Search Trials' },
                { to: '/how-it-works', label: 'How It Works' },
                { to: '/blog', label: 'Blog' },
                { to: '/knowledge', label: 'Knowledge Center' },
                { to: '/faq', label: 'FAQ' },
                { to: '/contact', label: 'Contact Us' },
              ].map(l => (
                <div key={l.to} style={{ marginBottom: 10 }}>
                  <Link to={l.to} style={linkStyle} onMouseEnter={over} onMouseLeave={out}>{l.label}</Link>
                </div>
              ))}
            </div>
            <div>
              <div style={colLabel}>Account</div>
              {[
                { to: '/register', label: 'Sign Up Free' },
                { to: '/login', label: 'Sign In' },
                { to: '/profile', label: 'Profile' },
              ].map(l => (
                <div key={l.to} style={{ marginBottom: 10 }}>
                  <Link to={l.to} style={linkStyle} onMouseEnter={over} onMouseLeave={out}>{l.label}</Link>
                </div>
              ))}
            </div>
            <div>
              <div style={colLabel}>Data</div>
              <div style={{ marginBottom: 10 }}>
                <a href="https://clinicaltrials.gov" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseEnter={over} onMouseLeave={out}>ClinicalTrials.gov ↗</a>
              </div>
              <div style={{ marginBottom: 10 }}>
                <a href="https://clinicaltrials.gov/data-api/api" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseEnter={over} onMouseLeave={out}>API Documentation ↗</a>
              </div>
              <div style={{ marginBottom: 10 }}>
                <Link to="/contact" style={linkStyle} onMouseEnter={over} onMouseLeave={out}>Contact Us</Link>
              </div>
              <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid #2a2a2a' }}>
                <div style={colLabel}>Contact</div>
                <a href="mailto:support@biomedarticles.com" style={{ display: 'block', color: '#b8b2a4', fontSize: 12, textDecoration: 'none', marginBottom: 6 }}
                  onMouseEnter={over} onMouseLeave={out}>
                  support@biomedarticles.com
                </a>
                <div style={{ color: '#b8b2a4', fontSize: 12, marginBottom: 6 }}>540-322-7406 (text only)</div>
                <div style={{ color: '#7a7567', fontSize: 11, lineHeight: 1.6 }}>2003 Plank Road #1283<br />Fredericksburg, VA 22401</div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ borderTop: '1px solid #2a2a2a', paddingTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <div style={{ color: '#7a7567', fontSize: 12, fontFamily: 'var(--font-mono)', letterSpacing: '0.5px' }}>
            © {new Date().getFullYear()} BioMedArticles · Public Health Solutions LLC
          </div>
          <div style={{ color: '#7a7567', fontSize: 12, maxWidth: 480, lineHeight: 1.5 }}>
            Data sourced from ClinicalTrials.gov. Not affiliated with NIH or the U.S. government. Not medical advice.
          </div>
        </div>
      </div>
    </footer>
  );
}
